import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Login from "./pages/auth/Login";
import AdminLayout from "./layouts/admin/Layout";
import Dashboard from "./pages/admin/dashboard/Dashboard";
import SchoolDetails from "./pages/admin/schoolDetails/SchoolDetails";
import InProgressActivities from "./pages/admin/inProgressActivities/InProgressActivities";
import CompletedActivities from "./pages/admin/completedActivities/CompletedActivities";
import PreviewGrade from "./pages/admin/previewGrades/PreviewGrades";
import AllActivities from "./pages/admin/allActivities/AllActivities";
import SectionHeadAllActivities from "./pages/sectionHead/allActivities/AllActivities";
import SectionHeadCompletedActivities from "./pages/sectionHead/completedActivities/CompletedActivities"
import SectionHeadInProgressActivities from "./pages/sectionHead/inProgressActivities/InProgressActivities"
import SectionHeadCompareGrades  from "./pages/sectionHead/compareGrades/PreviewGrades"
import SectionHeadEssayPreviewPage from "./pages/sectionHead/essayPreviewPage/EssayPreviewPage"
import EssayPreviewPage from "./pages/admin/essayPreviewPage/EssayPreviewPage";
import ScheduleActivities from "./pages/admin/scheduleActivities/ScheduleActivities";
import Login from "./pages/auth/Login";
import SectionHeadDashboard from "./pages/sectionHead/dashboard/Dashboard"
import SupervisorDashboard from "./pages/supervisor/dashboard/Dashboard"
import SupervisorEssayPreviewPage from "./pages/supervisor/essayPreviewPage/EssayPreviewPage"
import EmailTemplates from "./pages/admin/emailTemplates.jsx/EmailTemplates";
import SupervisorInitialGrades from "./pages/supervisor/initialGrades/InitialGrades"
import SupervisorFinalGrades from "./pages/supervisor/finalGrades/FinalGrades"
import SupervisorCompareGrades from "./pages/supervisor/compareGrades/CompareGrades"
import SupervisorGiveFeedBack from "./pages/supervisor/feedback/GiveFeedback"
import Users from "./pages/admin/manageAccess/users/Users";
import Roles from "./pages/admin/manageAccess/roles/Roles";
import ManageAccess from "./pages/admin/manageAccess";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="manage-access" element={<ManageAccess />} >
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          </Route>
        

          <Route path="school-details" element={<SchoolDetails />} />
          <Route path="in-progress-activities" element={<InProgressActivities />} />
          <Route path="completed-activities" element={<CompletedActivities />} />
          <Route path="grade-preview" element={<PreviewGrade />} />
          {/* <Route path="grade-preview" element={<PreviewGrade />} /> */}
          <Route path="email-templates" element={<EmailTemplates />} />



          <Route path="all-activities" element={<AllActivities />} />
          <Route path="schedule-activities" element={<ScheduleActivities />} />
          <Route path="essay-preview-page" element={<EssayPreviewPage />} />
        </Route>
        {/* sectionHead */}
        <Route path="/section-head" element={<AdminLayout />}>
          <Route path="dashboard" element={<SectionHeadDashboard />} />
          <Route path="all-activities" element={<SectionHeadAllActivities />} />
          <Route path="in-progress-activities" element={<SectionHeadInProgressActivities />} />
          <Route path="completed-activities" element={<SectionHeadCompletedActivities />} />
          <Route path="compare-grades" element={<SectionHeadCompareGrades  />} />
          <Route path="essay-preview-page" element={<SectionHeadEssayPreviewPage />} />
        </Route>
        {/* supervisor  */}
        <Route path="/supervisor" element={<AdminLayout />}>
          <Route path="dashboard" element={<SupervisorDashboard />} />
          <Route path="essay-preview-page" element={<SupervisorEssayPreviewPage />} />
          <Route path="initial-grades" element={<SupervisorInitialGrades />} />
          <Route path="final-grades" element={<SupervisorFinalGrades />} />
          <Route path="compare-grades" element={<SupervisorCompareGrades />} />
          <Route path="give-feedback" element={<SupervisorGiveFeedBack />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
